<template>
  <div>
    <CollectionView searchable :endpoint="utilities.path('modules/applications/categories/@/questions', categoryId)" v-model:reload="reload">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("questions") }}</h4>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("content") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <div style="white-space: pre-line; word-break: break-word; min-width: 300px">{{ item.content }}</div>
                  </div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="editing = item">
                        <i class="fas fa-edit"></i>
                      </ButtonView>
                      <TargetedModalHttpFormView size="small" :endpoint="utilities.path('modules/applications/questions/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <div class="mb-4">{{ item.content }}</div>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalHttpFormView :endpoint="creating ? utilities.path('modules/applications/categories/@/questions', categoryId) : utilities.path('modules/applications/questions/@', editing?.id)" :method="creating ? 'post' : 'put'" :content="editing" :active="creating || editing !== undefined" @update:active="creating = false; editing = undefined" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="d-flex flex-column g-4">
          <InputView type="text" v-model:value="content.content" :title="translate('content')" :errors="errors.content" required/>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="submit">
              {{ translate("save") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false; editing = undefined">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </ModalHttpFormView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, InputView, SpinnerView, utilities, TargetedModalHttpFormView, ModalHttpFormView} from "@/niftybit";
import {ref} from "vue";

defineProps({
  categoryId: String
});

const reload = ref(false);
const creating = ref(false);
const editing = ref(undefined);

</script>